/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EcardService {

    /**
     * @param code
     * @returns binary
     * @throws ApiError
     */
    public static ecardPdf(
        code?: string | null,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Ecard/pdf',
            query: {
                'code': code,
            },
        });
    }

    /**
     * @param code
     * @returns string Returns redirect Url for successfull redeem.
     * @throws ApiError
     */
    public static ecardRedeem(
        code?: string | null,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Ecard/redeem',
            query: {
                'code': code,
            },
            errors: {
                403: `User is not authenticated`,
                404: `Cannot find ecard with specified code`,
            },
        });
    }

    /**
     * @param app
     * @returns string Return Ecard Design html template as string
     * @throws ApiError
     */
    public static ecardGetTemplate(
        app: string | null = 'klangio',
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Ecard/template',
            query: {
                'app': app,
            },
        });
    }

    /**
     * @param orderId
     * @returns string Returns the Gift Card Pdf as UTF8 string for the given order id
     * @throws ApiError
     */
    public static ecardDelivery(
        orderId?: string | null,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Ecard/Delivery',
            query: {
                'order_id': orderId,
            },
            errors: {
                404: `Gift Card with the given order id cannot be found0`,
            },
        });
    }

}
